"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _icons = require("./icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const iconMap = {
  plus: _icons.Plus,
  close: _icons.Close,
  home: _icons.Home,
  users: _icons.Users,
  settings: _icons.Settings,
  document: _icons.Document,
  download: _icons.Download,
  minus: _icons.Minus,
  "left-arrow": _icons.LeftArrow,
  "right-arrow": _icons.RightArrow,
  "down-caret": _icons.DownCaret,
  "right-caret": _icons.RightCaret
};

const StyledBox = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "IconSvg__StyledBox",
  componentId: "qvkw2h-0"
})(["opacity:", ";pointer-events:", ";"], p => p.disabled ? 0.5 : 1, p => p.disabled ? "none" : "auto");

const StyledSVG = _styledComponents2.default.svg.withConfig({
  displayName: "IconSvg__StyledSVG",
  componentId: "qvkw2h-1"
})(["height:", "px;width:", "px;cursor:pointer;"], p => p.width ? p.width : "20", p => p.width ? p.width : "20");

const IconSvg = (_ref) => {
  let { name, disabled } = _ref,
      props = _objectWithoutProperties(_ref, ["name", "disabled"]);

  const MappedIcon = iconMap[name];
  if (MappedIcon) {
    return _react2.default.createElement(
      StyledBox,
      { disabled: disabled },
      _react2.default.createElement(
        StyledSVG,
        _extends({
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, props),
        _react2.default.createElement(MappedIcon, props)
      )
    );
  }

  return _react2.default.createElement("div", null);
};

IconSvg.propTypes = {
  name: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool,
  color: _propTypes2.default.string
};

IconSvg.defaultProps = {
  disabled: false
};

exports.default = IconSvg;